class EmailUtils {
	static isValidEmail = email => {
		const normalizedEmail = String(email || "").trim();

		if (!normalizedEmail) {
			return false;
		}

		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
	};

	static isValidEmailList = emails => {
		if (!Array.isArray(emails) || emails.length === 0) {
			return false;
		}

		return emails.every(email => EmailUtils.isValidEmail(email));
	};

    static validateEmail(email) {
    if (!email || email.trim() === '') {
      return false;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

  static formatEmail(email) {
    return email.toLowerCase().trim();
  }

}
export default EmailUtils;